module.exports = __webpack_public_path__ + "b5c72aa5e7a36c0aa6e74a2b84460a1b.svg";